import {PhoneNumberFormat, PhoneNumberUtil} from "google-libphonenumber";
import * as React from "react";
import FormInput from "../input";
import Select from "../select";
import * as CODES from "./calling-codes";

export interface PhoneInputProps {
    disabled?: boolean;
    label?: string;
    value?: string;
    onChange: (number) => void;
}

export interface PhoneInputState {
  code: any;
  number: string;
  errors: string[];
}

export default class PhoneInput extends React.Component<PhoneInputProps, PhoneInputState> {
    constructor(props) {
        super(props);
        this.state = {
            code: "34",
            number: "",
            errors: [],
        };
    }

    public componentWillReceiveProps(nextProps: PhoneInputProps) {
      if (!!nextProps.value && nextProps.value !== this.props.value) {
        this.validatePhoneNumber(nextProps.value);
        const values = nextProps.value.split(" ");
        this.setState({
          code: values[0].replace("+", ""),
          number: values[1],
        });
      }
    }

    public componentDidMount() {
        if (this.props.value !== undefined) {
            const values = this.props.value.split(" ");
            this.setState({
                code: values[0].replace("+", ""),
                number: values[1],
            });
        }
    }

    public validatePhoneNumber = (phoneNumber) => {
        /*
        Phone number validation using google-libphonenumber
        */
        let valid = false;
        try {
          const phoneUtil = PhoneNumberUtil.getInstance();
          valid =  phoneUtil.isValidNumber(phoneUtil.parse(phoneNumber));
        } catch (e) {
          valid = false;
          this.setState({
              errors: ["Invalid phone number"],
          });
        }
        if (valid) {
            this.setState({
                errors: [],
            });
            this.props.onChange(phoneNumber);
        } else {
            this.setState({
                errors: ["Phone number " + phoneNumber + " is not valid"],
            });
        }
      }

    public getValidNumber = (phoneNumber)  => {
        const phoneUtil = PhoneNumberUtil.getInstance();
        const parsedNumber = phoneUtil.parse(phoneNumber);
        return phoneUtil.format(parsedNumber, PhoneNumberFormat.INTERNATIONAL);
      }

    public onChange = (number) => {
        this.setState({
          number,
        }, () => this.validatePhoneNumber("+" + this.state.code + " " + number));

      }

    public render() {
        return (
            <div className="phone-input">
                <label>{this.props.label}</label>
                <div className="input-cont">
                    <div className="phone-input-container">
                        <Select
                          label=""
                          keyProperty="value"
                          canFilter={true}
                          showArrow={true}
                          mode="edit"
                          placeholder="code"
                          textProperty="format"
                          value={this.state.code}
                          onChange={(t) => this.setState({code: t.value})}
                          options={CODES.default.map((i) => ({code: i.code, value: i.value, format: `+${i.value}`}))}
                        />
                        <FormInput
                              className="edition-count-input"
                              type="number"
                              disabled={this.props.disabled}
                              value={this.state.number}
                              onChange={(e) => this.onChange(e)}
                        />
                    </div>
                    {this.state.errors &&
                        this.state.errors.map((item, index) => {
                            return <p key={"input-error" + index} className="input-error">{item}</p>;
                        })
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/data-component/phone-input.tsx